import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';
import { FaShoppingBag } from '@react-icons/all-files/fa/FaShoppingBag';
import { Link } from 'gatsby';

import { Selectors, useCart } from '../../../hooks/use-cart';
import { Url } from '../../../misc/enums';
interface CartIconProps extends React.HTMLAttributes<HTMLDivElement> {}

export const CartIcon: React.FC<CartIconProps> = ({ className = '', ...props }) => {
	const cartItems = useCart(Selectors.cartItems);
	const numCartItems = cartItems.length;

	return (
		<div
			className={cn('relative inline-flex items-center', className)}
			data-test-cartitemsnum={numCartItems}
			data-testid="cart-num-items"
			aria-label="Warenkorb"
			{...props}
		>
			<FaShoppingBag className="h-5 w-5 text-current" />
			{numCartItems > 0 && (
				<div
					className={cn(
						'absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs text-white',
						numCartItems >= 10 ? 'h-5 w-5' : 'h-4 w-4',
					)}
				>
					{numCartItems}
				</div>
			)}
		</div>
	);
};
